export default __webpack_public_path__ + "static/media/globo.ae0fffd6.png";